



















































































































import { Component, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const dateFormat = require('bmh/date-format');
const getUrl = require('bmh/url-with-param');
const API: any = {
  query: `${FCAPI}/shang/promotion/bargain/ware`,
};
function getData(remote?: FcapiRemotePagination<any>) {
  remote = (remote || {}) as FcapiRemotePagination<any>;
  return {
    total: remote.total || 0,
    limit: remote.limit || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    current: +remote.current || 0,
  };
}

const WARE_TYPE = [
  {
    label: '全部',
    value: 0,
  },
  {
    label: '实物',
    value: 1,
  },
  {
    label: '虚拟',
    value: 2,
  },
];
interface QueryParams {
  name?: string;
  type?: number;
  current?: number;
}
@Component
export default class AddBargainFirst extends Vue {
  backup_table_data: any = [];
  table_data: any = [];
  current_page: number = 1;
  is_loading: boolean = false;
  is_show_ware_modal: boolean = false;
  modal_table_data: FcapiRemotePagination<any> = getData();
  select_ware_type: number = 0;
  ware_name: string = '';
  checked_ware: any[] = [{}];
  get ware_type() {
    return WARE_TYPE;
  }
  addWare() {
    if (!this.checked_ware[0].id) {
      this.$message.error('请勾选商品');
      return;
    }
    this.table_data = this.checked_ware;
    this.backup_table_data = this.checked_ware;
    this.checked_ware = [{}];
    this.is_show_ware_modal = false;
  }
  async clickSearchBtn() {
    const query_params: QueryParams = {
      name: this.ware_name,
      type: this.select_ware_type,
    };
    this.query(query_params);
  }
  clearForm() {
    this.ware_name = '';
    this.select_ware_type = 0;
    this.query();
  }
  checkedWare(item: any) {
    this.checked_ware = [];
    this.backup_table_data = [];
    this.checked_ware.push(item);
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }
  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  nextStep() {
    if (this.table_data.length <= 0) {
      this.$message.error('请勾选商品');
      return;
    }
    storage.setItem('ware_info', JSON.stringify(this.table_data[0]));
    this.$router.push('/promotion/bargain/add-second');
  }

  async closeModal() {
    this.checked_ware = [{}];
    this.backup_table_data = this.table_data;
    this.is_show_ware_modal = false;
    this.current_page = 1;
    await this.query({ current: this.current_page });
  }
  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.current_page = next_page;
    this.query({
      current: this.current_page,
    });
  }
  async query(query_params?: QueryParams) {
    this.is_loading = true;
    this.modal_table_data = getData();
    const url = getUrl(API.query, query_params);
    const res = await this.$axios.get(url);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.is_loading = false;
    this.modal_table_data = getData(res.data.data);
  }
  async created() {
    await this.query();
  }
}
